// Layout
const dashboardLayout = () => import('@/layouts/DashboardLayout/dashboardLayout.vue')

const allWithdraws = () => import('./views/index')

// start Routes
export default [
  {
    path: '/withdraw',
    name: 'withdraw',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'withdraw',
      meta: {
        name: 'withdraw',
        parentName: 'marketplace',
        userType: '',
        permission: ''
      },
      component: allWithdraws
    }
    ]
  }
]
